'use client';

import { useEffect, useState } from 'react';

import Cookies from 'js-cookie';

/**
 * Dual-compatible hook that works in both App Router and Pages Router contexts
 * Extracts PartnerStack tracking parameters from URL and stores them in cookies
 *
 * This implementation uses window.location directly to avoid router-specific hooks,
 * making it compatible with both routing systems.
 */
export function usePartnerStackCookie() {
    const [params, setParams] = useState<{
        idbn?: string;
        fpr?: string;
        prms?: string;
    }>({});

    // Extract params from URL on mount (client-side only)
    useEffect(() => {
        if (typeof window === 'undefined') return;

        const searchParams = new URLSearchParams(window.location.search);
        const idbn = searchParams.get('idbn') || undefined;
        const fpr = searchParams.get('fpr') || undefined;
        const prms = searchParams.get('prms') || undefined;

        setParams({ idbn, fpr, prms });
    }, []);

    useEffect(() => {
        const { idbn, fpr, prms } = params;

        if (!idbn && !fpr && !prms) {
            return;
        }

        if (idbn) {
            Cookies.set('ico_idbn', idbn, {
                domain: '.iconosquare.com',
                expires: 30
            });
        }

        if (fpr) {
            Cookies.set('fpr', fpr, {
                domain: '.iconosquare.com',
                expires: 30
            });
        }

        if (prms) {
            Cookies.set('prms', prms, {
                domain: '.iconosquare.com',
                expires: 1
            });
        }

        // Clear query params without reload using History API
        if (idbn || fpr || prms) {
            const url = new URL(window.location.href);
            url.searchParams.delete('idbn');
            url.searchParams.delete('fpr');
            url.searchParams.delete('prms');
            const newUrl = url.pathname + (url.search || '') + url.hash;
            // Use History API which works in both router contexts
            window.history.replaceState(window.history.state, '', newUrl);
        }
    }, [params]);
}
